import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

/**
 * A very lenient validator for PEM files. Only checks for the presence of
 * -----BEGIN ...-----
 */
function pemValidator(val) {
	if (_.isNil(val) || _.isEmpty(val)) return

	// PEM file format regex pattern
	const pemPattern = /^\s*-----BEGIN .*?-----/

	// Check if the value matches the PEM format
	if (!pemPattern.test(val)) {
		return i18n.get('admin.certSendWithRESTImports.error.invalidPemFile')
	}
}

export default pemValidator

pemValidator.__filename__ = 'components/validators/pem-file-validator.js'
